import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en.json';
import deTranslation from './locales/de.json';
import czTranslation from './locales/cs.json';
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    resources: {
        en: { translation: enTranslation },
        de: { translation: deTranslation },
        cs: { translation: czTranslation },
    },
    fallbackLng: 'de', // Default language if detection fails
    supportedLngs: ['en', 'de', 'cs'],
    nonExplicitSupportedLngs: true,
    detection: {
        order: ['localStorage', 'cookie', 'navigator', 'htmlTag', 'querystring'],
        caches: ['localStorage', 'cookie'], // Save the detected language
    },
    interpolation: {
        escapeValue: false, // React already escapes values
    },
});
export default i18n;
